import React from 'react'
import OnbordingForm from '../components/OnbordingForm.jsx'
import Subscribe from '../components/Subscribe.jsx'

const Onbording = () => {
  return (
    <>
      <OnbordingForm />
      <Subscribe />
    </>
  )
}

export default Onbording
